import "./css/Main.css";
import Footer from "../components/Footer";
import Navbar from "../components/Navbar";
import  './css/Maintain.css'
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faWarning } from "@fortawesome/free-solid-svg-icons";

function Home() {
  return (
    <>
    <Navbar />
        <div className='maintain'>
            <div className="container">
                <h4><FontAwesomeIcon icon={ faWarning} /> Sorry, this Page is Under Maintenance !!!</h4>
            <h5>We are sorry for any Inconveniences caused.</h5>
            <p>DON'T FRET ! Our Team is working on it</p>
            </div>
        </div>
    <Footer />
    
    </>
  );
}

export default Home;